import PropTypes from 'prop-types';
import React from 'react';
import { HStack } from '~/native-ui/native-base';
import { Pressable } from '~/native-ui/Pressable';
import { extractSpacingProps } from '~/native-ui/utils';
import { Switch as NBSwitch } from 'native-base';
import { FormControl } from '~/native-ui/FormControl';
export class Switch extends React.Component {
    static propTypes = {
        checked: PropTypes.bool,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        onChange: PropTypes.func,
        error: PropTypes.string,
    };

    handleLabelClick = () => {
        this.props.onChange?.(!this.props.checked);
    };

    webStyle = { cursor: 'pointer' };
    render() {
        const [spaceProps, props] = extractSpacingProps(this.props);
        let { checked, label, tooltip, onChange, error, _text = {}, ...others } = props;

        const switchProps = {
            ...others,
            isChecked: checked,
            onToggle: onChange,
        };

        _text = {
            ..._text,
            textTransform: _text.textTransform ?? 'uppercase',
            fontSize: _text.fontSize ?? 'xs',
            color: 'primary.500',
        };

        return (
            <FormControl {...spaceProps}>
                <HStack space={3} alignItems="center">
                    <NBSwitch {...switchProps} />
                    {label && (
                        <Pressable onPress={this.handleLabelClick}>
                            <FormControl.Label
                                _web={this.webStyle}
                                mb="0"
                                mr="2"
                                _text={_text}
                                label={label}
                                tooltip={tooltip}
                            />
                        </Pressable>
                    )}
                </HStack>
                {error ? <FormControl.ErrorMessage>{error}</FormControl.ErrorMessage> : null}
            </FormControl>
        );
    }
}
